import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  aiAssitantChatBox: {
    width: "inherit",
    borderRadius: "8px",
    border: "1px solid #D0D5DD",
    background: "#FFF",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    overflow: "hidden",
    display: "none",
    // margin: "18px 12px",
  },
  showAiAssistantChatBox: {
    overflow: "auto",
    height: "250px",
    display: "block",
  },
  header: {
    backgroundColor: "#18181B",
    padding: "4px 6px",
  },
  title: {
    fontWeight: 500,
    color: "#FFF",
    fontFamily: "Inter",
    fontSize: 14,
    lineHeight: "24px",
    "& svg": {
      color: "#FFF",
    },
  },
  contentText: {
    color: "#667085",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "24px",
    marginBottom: "15px",
    textAlign: "justify",
    padding: "0px 5px",
  },
  actions: {
    paddingBottom: "15px",
  },
  inputContainer: {
    padding: "10px 20px",
    borderRadius: "4px",
  },

  replacetext: {
    // marginTop: "20px",
    display: "flex",
    justifyContent: "flex-end",
    // marginBottom: "20px",
    cursor: "pointer",
  },

  input: {
    flex: 1,
    "& .mantine-Input-input": {
      color: "#3F3F46",
      fontSize: 14,
      fontFamily: "Inter",
      fontWeight: 400,
    },
  },

  generateresponse: {
    width: "100%",
    height: "15vh",
    border: "1px solid #D4D4D8",
    borderRadius: "7px",
    // margin: "1rem 2rem",
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center",
    // padding: "10px",

  },

  scrollBg: {
    padding: "0 10px",
    "& .mantine-ScrollArea-viewport": {
      backgroundColor: "transparent",
    },
    "& .mantine-ScrollArea-thumb": {
      backgroundColor: "#18181B",
    },
  },
}));

export default useStyles;
